import { defaultTo } from "lodash";
import { makeObservable, observable } from "mobx";
import { PGRColorModel } from ".";
import { IModel, Model, ModelRecord } from "./Model";

export interface IPetColorModel extends IModel {
  petColorId: number;
  name: string;
  pgrColorId: number;
  pgrColor: PGRColorModel;
}

export class PetColorModel
  extends Model
  implements ModelRecord<IPetColorModel>
{
  @observable petColorId: number;
  @observable name: string;
  @observable pgrColorId: number;
  @observable pgrColor: PGRColorModel;

  constructor(params?: Partial<IPetColorModel>) {
    super(params);
    this.petColorId = defaultTo(params?.petColorId, 0);
    this.name = defaultTo(params?.name, "");
    this.pgrColorId = defaultTo(params?.pgrColorId, 0);
    this.pgrColor = params?.pgrColor
      ? new PGRColorModel(params?.pgrColor)
      : new PGRColorModel();
    makeObservable(this);
  }
}
